<template>
	<div id="save-custom-block-modal" class="modal-new hidden">
		<svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
			<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>
		<span class="title">Save a Custom Layout</span>

		<input type="text" name="custom-block-name" v-model.trim="name" placeholder="Name" class="regex-check" />
		<div class="buttons-continer">
			<button type="button" class="modal-btn --primary" @click="saveLayout">Save</button>
			<button type="button" class="modal-btn --cancel" data-modal-action="close-modal">Cancel</button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			name: "",
			message: {
				success: `Custom Layout Saved Successfully`,
				fail: `Saving Custom Layout Failed`,
			},
		};
	},
	methods: {
		async saveLayout() {
			if (this.name == "") this.name = `Layout.${Date.now()}.json`;
			else this.name = `${this.name}.${Date.now()}.json`;

			let blocks = window.lutify.getSelectedBlocksList();
			let file = new File([JSON.stringify(blocks)], this.name, { type: "application/json" });

			window.UI.hideModal();
			this.$store
				.dispatch("UserFiles/postLayout", file)
				.then(response => {
					this.$store.dispatch("UserFiles/fetchLayouts");
					window.layoutsStore.setItem(response.id, blocks);
					window.UI.message.activate(this.message.success);
				})
				.catch(() => {
					window.UI.message.activate(this.message.fail);
				});
		},
	},
};
</script>

<style></style>
